import { DocumentTypeCode } from '@/api/types';

export const YesNoSelectOptions = {
  YES: {
    id: '1',
    label: 'Так',
  },
  NO: {
    id: '0',
    label: 'Ні',
  },
} as const;

export const DOCUMENT_FIELD_MAPPINGS: Partial<Record<DocumentTypeCode, (doc: any) => Record<string, any>>> = {
  [DocumentTypeCode.PASSPORT]: (doc) => ({
    serial: doc.info.serialNumberDoc,
    auth_dep: doc.info.auth_dep ?? doc.info.issue,
    issued: doc.info.dateIssue ?? doc.info.date,
  }),

  [DocumentTypeCode.ID_CARD]: (doc) => ({
    serial: doc.info.serialNumberDoc,
    issue: doc.info.auth_dep,
    issued: doc.info.date,
    expired: doc.info.expirationDate,
    unzr: doc.info.unzr,
  }),

  [DocumentTypeCode.INTERNATIONAL_PASSPORT]: (doc) => ({
    serial: doc.info.serialNumberDoc,
    issue: doc.info.auth_dep,
    issued: doc.info.date,
    expired: doc.info.expirationDate,
    unzr: doc.info.unzr,
  }),

  [DocumentTypeCode.RESIDENCE]: (doc) => ({
    serial: doc.info.serialNumberDoc,
    issue: doc.info.auth_dep,
    issued: doc.info.date,
    expired: doc.info.expirationDate,
    unzr: doc.info.unzr,
  }),

  [DocumentTypeCode.OLD_RESIDENCE]: (doc) => ({
    serial: doc.info.serialNumberDoc,
    issue: doc.info.auth_dep,
    issued: doc.info.date,
  }),

  [DocumentTypeCode.TEMPORARY_RESIDENCE]: (doc) => ({
    serial: doc.info.serialNumberDoc,
    issue: doc.info.auth_dep,
    issued: doc.info.date,
    expired: doc.info.expirationDate,
    unzr: doc.info.unzr,
  }),
};
